import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoriaClinicaCadastroComponent } from './historia-clinica-cadastro/historia-clinica-cadastro.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CrudBarModule } from '../libs/crud-bar/crud-bar.module';
import { ButtonModule, CheckBoxAllModule } from '@syncfusion/ej2-angular-buttons';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { TabAllModule, ToolbarAllModule } from '@syncfusion/ej2-angular-navigations';
import { DatePickerAllModule, DateRangePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NumericTextBoxAllModule, TextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { LightInfoModule } from '../libs/light-info/light-info.module';
import { EditButtonModule } from '../libs/edit-button/edit-button.module';
import { ErrorHandlerModule } from '../libs/error-handler/error-handler.module';
import { PesquisaModule } from '../pesquisa/pesquisa.module';
import { DropDownButtonAllModule, SplitButtonAllModule } from '@syncfusion/ej2-angular-splitbuttons';
import { PanelModule } from '../libs/panel/panel.module';
import { AxSelectModule } from '../libs/ax-select/ax-select.module';
import { ChartAllModule } from '@syncfusion/ej2-angular-charts';
import { DialogAllModule, TooltipAllModule } from '@syncfusion/ej2-angular-popups';
import { DebounceClickModule } from '../libs/debounce-click/debounce-click.module';
import { CompartilhadoModule } from '../compartilhado/compartilhado.module';
import { DoencaModule } from '../doenca/doenca.module';



@NgModule({
  declarations: [
    HistoriaClinicaCadastroComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CrudBarModule,
    ButtonModule,
    GridAllModule,
    ToolbarAllModule,
    DateRangePickerModule,
    DatePickerAllModule,
    NumericTextBoxAllModule,
    TooltipAllModule,
    TextBoxAllModule,
    DoencaModule,
    CheckBoxAllModule, 
    LightInfoModule,
    EditButtonModule,
    ErrorHandlerModule,
    PesquisaModule,
    SplitButtonAllModule,
    PanelModule,
    AxSelectModule,
    TabAllModule,
    PesquisaModule,
    ChartAllModule,
    DropDownButtonAllModule,
    DialogAllModule,
    CompartilhadoModule,
    DebounceClickModule,
    MultiSelectModule
  ],
  exports: [
    HistoriaClinicaCadastroComponent
  ]
})
export class HistoriaClinicaModule { }
